<template>
  <HeaderProvince :to="'/'" @change_City_From="changeFrom" @change_City_To="changeTo" />

  <div id="refresh-container">
    <div style="padding-top: 6rem;">
      <Placeholder v-if="loading" />

      <div v-else style="background-color: white">
        <FixLimited v-if="freeCalls !== 'false'" :freeCalls="freeCalls" />
        <div v-if="this.$route.query.from == 8">
          <button type="button" class="btn btn-outline-primary mx-3" data-bs-toggle="modal"
            data-bs-target="#actionFilterCity">
            <ion-icon name="location-outline"></ion-icon>
            {{ this.selectCity ?? 'انتخاب شهر' }}
          </button>
          <!-- Form Action Sheet -->
          <div class="modal fade modalbox" id="actionFilterCity" data-bs-backdrop="static" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">انتخاب شهرستان</h5>
                </div>
                <div class="modal-body pt-2 px-0">
                  <form @submit.prevent="searchProvinceCities">
                    <div class="input-list mb-4">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="allCities" v-model="selectAll"
                          @change="handleSelectAll">
                        <label class="form-check-label" for="allCities">
                          همه شهرستان‌ها
                        </label>
                      </div>

                      <!-- لیست شهرها -->
                      <div class="form-check" v-for="(city, index) in citiesOfProvince" :key="index">
                        <input type="checkbox" class="form-check-input" :id="'customCheckc' + index" :value="city.id"
                          v-model="cityIds" @change="handleCitySelection">
                        <label class="form-check-label" :for="'customCheckc' + index">
                          {{ city.name }}
                        </label>
                      </div>
                    </div>

                    <div class="form-group basic" style="position: fixed; bottom: 0px;">
                      <button type="submit" data-bs-dismiss="modal" class="btn background-ORANGE text-light btn-block">
                        ثبت
                      </button>
                    </div>
                  </form>

                </div>
              </div>
            </div>
          </div>
          <!-- * Form Action Sheet -->
        </div>

        <div class="section" v-for="(cargo, index) in cargos" :key="cargo.id" :class="[
          index !== 0 ? 'mt-3 mb-3' : '',
          index === 0 && isFreeCallsExceeded ? 'pt-45' : '',
          index === 0 ? 'mt-3 mb-3' : '',
          // index === 0 && !isFreeCallsExceeded ? '' : '',
        ]">
          <CardView :cargo="cargo" />
        </div>

        <button v-if="mode === 1 && loadingNext === 0" @click="nextLoadCargo" class="btn btn-success btn-block btn-lg">
          نمایش بار های بیشتر کلیک کنید...
        </button>

        <button v-else-if="loadingNext === 1" class="btn btn-warning btn-lg btn-block" type="button" disabled>
          <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
          درحال بارگذاری ...
        </button>
      </div>

      <a href="#" class="button goTop show">
        <ion-icon name="arrow-up-outline"></ion-icon>
      </a>
    </div>
  </div>
</template>

<script>
import Placeholder from "@/components/Placeholder.vue";
import CardView from "@/views/cargo/components/CardView.vue";
import HeaderProvince from "@/components/HeaderSearchProvince.vue";
import FixLimited from "@/components/FixLimited.vue";
import axios from "axios";
import PullToRefresh from "pulltorefreshjs";
import Swal from "sweetalert2";
import router from "@/router";
import delivery_methods from "@/delivery_methods";

export default {
  name: "Master",
  components: {
    CardView,
    Placeholder,
    HeaderProvince,
    FixLimited
  },
  data() {
    return {
      from: '',
      to: '',
      mode: 0,
      loading: false,
      loadingNext: 0,
      cargos: [],
      freeCalls: '',
      page: 1,
      total: 0,
      cityTo: [],
      cityFrom: [],
      citiesOfProvince: [],
      cityIds: [],
      selectCity: 'انتخاب شهر',
      cities: {
        from: null,
        to: null
      },
      location: {
        latitude: null,
        longitude: null,
      },
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      },
      postData: {
        selectedLoadingCitiesIds: '',
        selectedDischargeCitiesIds: '',
        fleet_id: '',
      },
      ptrInstance: null,
    };
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },
    isFreeCallsExceeded() {
      return this.freeCalls !== 'false' && this.freeCalls > 6;
    }
  },
  methods: {
    handleSelectAll() {
      if (this.selectAll) {
        this.cityIds = []; // اگر "همه" انتخاب شد، بقیه رو پاک کن
      }
    },
    handleCitySelection() {
      if (this.cityIds.length > 0 && this.selectAll) {
        this.selectAll = false; // اگر یکی از شهرها انتخاب شد، "همه" رو غیرفعال کن
      }
    },
    searchProvinceCities() {
      if (this.cityIds == null || this.selectAll) {
        this.searchProvince();
      }
      else {
        this.loading = true;
        axios.post(`${delivery_methods.BASE_URL}api/driver/v2/LoadsInCitiesProvince`, {
          cities: this.cityIds
        }, this.axiosConfig
        )
          .then((response) => {
            if (response.data.result == 1) {
              response.data.loads.length == 25 ? this.mode = 1 : this.mode = 0;
              this.loading = false;
              this.cargos = response.data.loads;
              setTimeout(() => {
                const savedPosition = localStorage.getItem('scrollPosition');
                window.scrollTo(0, savedPosition);
              }, 100);
              this.show = true;
            } else {
              Swal.fire({
                position: "center",
                icon: "error",
                title: 'در حال حاظر تا فاصله 250 کیلومتری شما باری ثبت نشده است',
                showConfirmButton: true,
                confirmButtonText: "بازگشت",
              }).then((result) => {
                this.searchProvince();
              });
            }

          });
      }

    },
    changeFrom(value) {
      if (value == 0) {
        this.getLocation();
      }
      else {
        this.postData.selectedLoadingCitiesIds = value;
        this.$router.push("/nearLoads?" +
          'from=' + value + '&' +
          'to=' + this.postData.selectedDischargeCitiesIds
        );
        this.searchProvince();
        if (this.postData.selectedLoadingCitiesIds == 8) {
          this.getCitiesOfProvince();
        }
      }

    },
    changeTo(value) {
      this.postData.selectedDischargeCitiesIds = value;
      this.$router.push("/nearLoads?" +
        'from=' + this.postData.selectedLoadingCitiesIds + '&' +
        'to=' + value
      );
      this.searchProvince();
    },
    searchProvince() {
      this.loading = true;
      axios.post(`https://core.iran-tarabar.ir/api/requestCitiesList`, this.postData)
        .then((res) => {
          this.cityTo = res.data.selectedDischargeCitiesIds.map((a) => a.id);
          this.cityFrom = res.data.selectedLoadingCitiesIds.map((a) => a.id);
          this.cityTo.forEach((element, index) => {
            this.cityTo[index] = "\n  " + element;
          });

          this.cityFrom.forEach((element, index) => {
            this.cityFrom[index] = "\n  " + element;
          });
          this.cities.from = JSON.stringify(this.cityFrom);
          this.cities.to = JSON.stringify(this.cityTo);

          axios.post(`https://core.iran-tarabar.ir/api/driver/searchLoadForDriver`,
            {
              selectedLoadingCitiesIds: this.cities.from,
              selectedDischargeCitiesIds: this.cities.to,
              fleet_id: this.postData.fleet_id,
            },
            this.axiosConfig
          )
            .then((response) => {
              // console.log(response);

              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              if (response.data.result == 0) {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: response.data.message,
                  showConfirmButton: true,
                  confirmButtonText: "تایید",
                  // timer: 2000,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.loading = false;
                    this.cargos = [];
                    window.location.href = "/nearLoads";
                  }
                });
              } else {
                response.data.loads.length == 25 ? this.mode = 1 : this.mode = 0;
                this.loading = false;
                this.cargos = response.data.loads;
                setTimeout(() => {
                  const savedPosition = localStorage.getItem('scrollPosition');
                  window.scrollTo(0, savedPosition);
                }, 100);
                this.show = true;
              }
            });
        }).catch((res) => {
          console.log(res);
        });
    },
    getLocation() {
      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError,
          {
            timeout: 5000,
            enableHighAccuracy: true
          }
        );

      } else {
        this.showError({ code: 0 });
      }
    },
    getCitiesOfProvince() {
      axios.get(`https://core.iran-tarabar.ir/api/driver/v2/getCitiesOfProvince/8`, this.axiosConfig)
        .then((response) => {
          console.log('awdawd');
          this.citiesOfProvince = response.data.cities
        });
    },
    showPosition(position) {
      const { latitude, longitude } = position.coords;
      this.location = { latitude, longitude };

      localStorage.setItem("latitude", latitude);
      localStorage.setItem("longitude", longitude);
      localStorage.setItem("locationTimestamp", Date.now());

      console.log("لوکیشن دریافت شد:", latitude, longitude);
      this.page = 1;
      this.loading = true;

      axios.post(`https://core.iran-tarabar.ir/api/driver/v2/searchTheNearestCargo`, {
        latitude,
        longitude,
        page: this.page
      }, this.axiosConfig)
        .then(({ data }) => {
          if (data.total == 0) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: 'راننده گرامی',
              text: 'تا فاصله ی 250 کیلومتری شما باری ثبت نشده است ',
              showConfirmButton: true,
              confirmButtonText: "تایید",
              // timer: 2000,
            }).then((result) => {
              if (result.isConfirmed) {
                router.push({ name: 'home' })
              }
            });
          }
          this.freeCalls = data.freeCalls;
          this.total = data.total;
          this.mode = data.loads.length > 0 ? 1 : 0;
          this.cargos = data.loads;
          this.updateLocation(this.location)
        })
        .catch(this.handleApiError)
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            const savedPosition = localStorage.getItem('scrollPosition');
            window.scrollTo(0, savedPosition || 0);
          }, 100);
        });
    },
    updateLocation(location) {
      axios.get(
        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=` + location.latitude + `&longitude=` + location.longitude + `&localityLanguage=fa`)
        .then((response) => {
          localStorage.setItem("city", response.data.city);
          axios.put(`https://core.iran-tarabar.ir/api/driver/updateLocation`, {
            latitude: location.latitude,
            longitude: location.longitude,
            city: response.data.city,
          }, this.axiosConfig).then(() => {
            //
          }).catch(() => {
            //
          });
        });
    },
    nextLoadCargo() {
      this.loadingNext = 1;
      this.page += 1;

      axios.post(`https://core.iran-tarabar.ir/api/driver/v2/searchTheNearestCargo`, {
        latitude: this.location.latitude,
        longitude: this.location.longitude,
        page: this.page
      }, this.axiosConfig)
        .then(({ data }) => {
          if (data.loads.length === 0) {
            this.mode = 0;
          } else {
            this.cargos.push(...data.loads);
          }
        })
        .catch(console.error)
        .finally(() => {
          this.loadingNext = 0;
        });
    },

    showError(error) {
      const messages = {
        1: "لطفا موقعیت مکانی خود را روشن کنید.",
        2: "اطلاعات موقعیت مکانی در دسترس نیست.",
        3: "دریافت موقعیت بیشتر از 5 ثانیه طول کشید.",
        0: "خطای ناشناخته در موقعیت‌یابی رخ داده است."
      };

      console.log(messages[error.code] || "خطای ناشناخته");

      // اگر تایم‌اوت شد
      if (error.code === 3) {
        this.$router.push({ name: "newLoads" });
      }
    },
    handleApiError(error) {
      if (error.response?.status === 401) {
        Swal.fire({
          title: "راننده محترم!",
          text: "شماره شما توسط دستگاه دیگری استفاده شده است.",
          icon: "error",
          confirmButtonText: "ورود مجدد!",
        }).then(() => {
          localStorage.clear();
          router.push({ name: 'login' });
        });
      }
    },
    initPullToRefresh() {
      if (this.ptrInstance) {
        this.ptrInstance.destroy();
      }
      this.ptrInstance = PullToRefresh.init({
        mainElement: '#refresh-container',
        onRefresh: this.refreshFromCacheOrLocation
      });
    },
    refreshFromCacheOrLocation() {
      const savedLat = localStorage.getItem("latitude");
      const savedLng = localStorage.getItem("longitude");
      const savedTime = localStorage.getItem("locationTimestamp");

      const now = Date.now();
      const isRecent = savedLat && savedLng && savedTime && (now - savedTime < 15 * 60 * 1000);
      this.loading = true;

      if (isRecent) {
        this.showPosition({
          coords: {
            latitude: parseFloat(savedLat),
            longitude: parseFloat(savedLng)
          }
        });
      } else {
        this.getLocation();
      }
    },
    saveScrollPosition() {
      localStorage.setItem('scrollPosition', window.scrollY);
    }
  },
  beforeMount() {
    this.refreshFromCacheOrLocation();
  },
  mounted() {
    this.initPullToRefresh();
    if (this.$route.query.from == 8) {
      this.getCitiesOfProvince();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.saveScrollPosition();
    next();
  },
  beforeUnmount() {
    this.ptrInstance?.destroy();
  }
};
</script>

<style>
.pt-45 {
  padding-top: 2rem !important;
}

#webpack-dev-server-client-overlay {
  display: none;
}
</style>